import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getLatestImports } from '../../api';

export const importsLatestGetSlice = createGetAsyncSlice({
	name: 'ImportsLatest',
	receive: true,
	request: true,
	requestHandler: getLatestImports,
	retainDataOnRequest: true
});
